import { render, staticRenderFns } from "./FileSize.vue?vue&type=template&id=3219e5a6&"
import script from "./FileSize.vue?vue&type=script&lang=ts&"
export * from "./FileSize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports